export default 'user-permission-upload'
